import { render } from "./TimelineComponent.vue?vue&type=template&id=28d44d3c&scoped=true"
import script from "./TimelineComponent.vue?vue&type=script&lang=js"
export * from "./TimelineComponent.vue?vue&type=script&lang=js"

import "./TimelineComponent.vue?vue&type=style&index=0&id=28d44d3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d44d3c"]])

export default __exports__